module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Pause Item',
        mainHeader: 'Are you sure you would like to pause your Auto-Replenish? You may resume at any time.',
        pause: 'Pause',
        cancel: 'Cancel',
        item: 'ITEM',
        qty: 'Qty',
        notRated: 'Not rated',
        oneReview: '1 review',
        yearlySavings: 'yearly savings'
    };

    return resources[label];
};
